import {
  EmployeeTimePeriodDetailsFragment,
  TimePeriodDetailsDocument,
  TimePeriodDetailsQuery,
  TimePeriodDetailsQueryVariables,
} from 'generated/resources/graphql'

import { useQuery } from 'modules/core/hooks/useQuery'

export type TimeBalanceTimeInfo =
  TimePeriodDetailsQuery['timeBalance']['timePeriodDetailsConnection']['nodes']

interface Props {
  variables: TimePeriodDetailsQueryVariables
}

export const useTimeBalanceTimePeriodDetails = ({ variables }: Props) => {
  const { loading, data, refetch } = useQuery(TimePeriodDetailsDocument, { variables })
  const timePeriodDetails: EmployeeTimePeriodDetailsFragment[] = data
    ? data.timeBalance.timePeriodDetailsConnection.nodes
    : []

  return {
    refetch,
    loading,
    timePeriodDetails,
  }
}
